import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParallaxProvider } from "react-scroll-parallax";
import { useRouter } from "next/router";
import { useCurrentChainInfo } from "@looksrare/utils";
import { NextSeo } from "next-seo";
import { useTranslation } from "next-i18next";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import Page from "components/Layout/Page";
import { AppLandingPageView } from "views/app/AppLandingPageView";

const AppLandingPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();

  const canonicalPathname = `/app`;
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    canonicalPathname,
    router,
    currentChainInfo.appUrl
  );

  const title = "Get the LooksRare Mobile App";
  const description =
    "The hottest collections, at your fingertips. Easy rewards tracking. Glorious portfolio analytics. Download the LooksRare app on iOS or Android to unlock Web3.";
  return (
    <Page>
      <NextSeo
        title={t("{{pageTitle}} | LooksRare", { pageTitle: title })}
        openGraph={{
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          url: canonical,
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/app-landing-page/meta.png`,
              alt: "LooksRare Mobile App",
              width: 1600,
              height: 900,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <ParallaxProvider>
        <AppLandingPageView />
      </ParallaxProvider>
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default AppLandingPage;
